import { render, staticRenderFns } from "./ChannelFeeListView.vue?vue&type=template&id=1ecdcce7&"
import script from "./ChannelFeeListView.vue?vue&type=script&lang=js&"
export * from "./ChannelFeeListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports